import { render, staticRenderFns } from "./YHBalanceBooksRecord.vue?vue&type=template&id=5bd8f618&scoped=true&"
import script from "./YHBalanceBooksRecord.vue?vue&type=script&lang=js&"
export * from "./YHBalanceBooksRecord.vue?vue&type=script&lang=js&"
import style0 from "./YHBalanceBooksRecord.vue?vue&type=style&index=0&id=5bd8f618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8f618",
  null
  
)

export default component.exports